<template>
  <div class="user_login_style">
    <div class="user_login_style1">
      <div class="login_button_style">登录账户</div>
      <div class="create_style">
        预定配置药时、务必登录账户或创建账户
      </div>
      <div>
        <div class="login_form_style">
          <el-form ref="form" :model="user" :rules="rules" label-position="top">
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="user.mobile" placeholder="请输入手机号码" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="user.password"
                placeholder="请输入密码"
                show-password
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="confirm_style">
          <el-button type="primary" @click="login_click">登录账号</el-button>
        </div>
        <div class="pro_style" @click="protect_click">
          个人信息保护条款
        </div>
      </div>
      <el-divider>未注册的用户</el-divider>
      <div class="login_style">
        <div class="login_style1" @click="reg_click">注册账户</div>
      </div>
    </div>
  </div>
</template>
<script>
import { pro_href } from "../assets/config/img";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      user: {
        mobile: null,
        password: null,
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(["setCgmUserVO"]),
    reg_click() {
      this.$router.push("/register");
    },
    protect_click() {
      window.open(pro_href);
    },
    login_click() {
      this.axios
        .post("/login", this.user, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.setCgmUserVO(JSON.stringify(res.data.data));
            if (this.cgmUserVO) {
              let userId = JSON.parse(this.cgmUserVO).userId;
              this.axios
                .get("/cgmOrder/getOrderCount", {
                  params: {
                    userId,
                  },
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.configFlag = res.data.data;
                    if(res.data.data > 0){
                      this.$router.push("/ConfigMedicine");
                    }else{
                      // this.$router.push("/spu?packageId=1731336393415692289");
                      this.$router.push("/");
                    }
                  }
                });
              }

            this.$message({ type: "success", message: "登录成功" });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .user_login_style1 {
    width: 100% !important;
  }
  .user_login_style {
    padding: 10px;
  }
}
::v-deep .el-input__inner {
  height: 47px !important;
  line-height: 50px !important;
  font-size: 17px;
  font-weight: bold;
}
.create_style {
  font-weight: bold;
}
.login_style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_style1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 50px;
  border: 1px solid #e5e9f0;
  background: #ffffff;
  color: #223344;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
}
.pro_style {
  text-align: center;
  color: rgb(229, 28, 81);
  font-weight: bold;
  cursor: pointer;
  font-size: 12px;
  margin-top: 7px;
}
::v-deep .el-button--primary {
  background: rgb(229, 28, 81);
  color: #fff;
  border-color: rgb(229, 28, 81);
  height: 57px;
  font-weight: bold;
  font-size: 17px;
  border-radius: 10px;
}
.user_login_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;
  padding: 40px;
}
.user_login_style1 > div {
  margin-bottom: 40px;
}
.login_button_style {
  // text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: rgb(34, 51, 68);
}
.user_login_style1 {
  width: 36%;
}
.login_form_style {
  margin-bottom: 40px;
}
.confirm_style {
  text-align: center;
}
</style>
